import React, { useContext } from 'react';

import { media } from 'context';
import { Animate, EmailInput, Layout, PhoneInput, TextInput } from 'ds';
import { actions } from 'store/OfficeRequest';
import {
  selectOfficeRequest,
  selectOfficeRequestReferralInfo,
  selectOfficeRequestUser
} from 'store/OfficeRequest/selectors';
import { selectUser } from 'store/User/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

interface Props {
  handleFocus?: VoidFunction;
  onBlur?: VoidFunction;
}

const UserFields: React.FC<Props> = ({ handleFocus, onBlur }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const { firstName, lastName, email, phone, callingCode } = useAppSelector(selectOfficeRequestUser) || {};
  const { jobTitle } = useAppSelector(selectOfficeRequest) || {};
  const { xs, sm } = useContext(media);
  const isMobile = xs || sm;
  const referralInfo = useAppSelector(selectOfficeRequestReferralInfo);

  return (
    <Layout>
      <Layout flex={!isMobile}>
        <Animate delay={20} {...(isMobile ? { marginTop: 16 } : { equalWidth: true })}>
          <TextInput
            autoFocus={!isMobile && !user}
            size="md"
            onChange={({ value }) => {
              dispatch(actions.setUser({ firstName: value }));
            }}
            label="First name"
            value={firstName}
            onFocus={handleFocus}
            onBlur={onBlur}
            name="first name"
            required
          />
        </Animate>
        <Animate delay={30} {...(isMobile ? { marginTop: 16 } : { equalWidth: true, marginLeft: 12 })}>
          <TextInput
            size="md"
            onChange={({ value }) => {
              dispatch(actions.setUser({ lastName: value }));
            }}
            label="Last name"
            value={lastName}
            onFocus={handleFocus}
            onBlur={onBlur}
            name="last name"
            required
          />
        </Animate>
      </Layout>
      <Animate delay={45} marginTop={16}>
        <EmailInput
          size="md"
          onChange={({ value }) => {
            dispatch(actions.setUser({ email: value }));
          }}
          label="Work email"
          value={email}
          onFocus={handleFocus}
          onBlur={onBlur}
          required
        />
      </Animate>
      <Animate delay={55} marginTop={16}>
        <PhoneInput
          size="md"
          onChange={({ value }) => {
            dispatch(actions.setUser({ phone: value }));
          }}
          label="Phone"
          value={phone}
          callingCode={callingCode}
          onCallingCodeChange={value => dispatch(actions.setUser({ callingCode: value }))}
          onFocus={handleFocus}
          onBlur={onBlur}
          autoFocus={!isMobile && !!user && !user.phone}
          required
        />
      </Animate>
      {!referralInfo && (
        <Animate delay={55} marginTop={16}>
          <TextInput
            size="md"
            onChange={({ value }) => {
              dispatch(actions.setJobTitle(value));
            }}
            label="Job title"
            value={jobTitle}
            onFocus={handleFocus}
            onBlur={onBlur}
            name="job title"
          />
        </Animate>
      )}
    </Layout>
  );
};

export default UserFields;
